import Entity from './Entity';
import { getLogger } from '../logger';

const logger = getLogger('schema');

function translateErrorMessages(validationResult, messages) {
  return {
    ...validationResult,
    helpText: messages[validationResult.helpText] || validationResult.helpText,
  };
}

function entityErrorsToErrorsMap(entityErrors, messages) {
  return entityErrors
    .filter(error => !error.valid)
    .reduce((errorsMap, error) => {
      const propPath = [...error.fieldTree, error.fieldName].join('.');
      return {
        ...errorsMap,
        [propPath]: translateErrorMessages(error.validationResult, messages),
      };
    }, {});
}

export function toBoolean(input) {
  if (typeof input === 'boolean') {
    return input;
  }
  const temp = input && input.toLowerCase();
  if (temp === 'true' || temp === 'on' || temp === 'yes') {
    return true;
  }
  return false;
}

export function createEntityValidator(metaId, source, schemaDescriptors, messages, callback) {
  if (source && schemaDescriptors && schemaDescriptors[metaId]) {
    logger.trace('Validate metaId', metaId, ' source', source, 'schemaDescriptors', schemaDescriptors);
    return () => {
      try {
        const entity = new Entity();
        entity.setData(source);
        entity.setMeta(schemaDescriptors, metaId);
        entity.validate();
        if (!entity.isValid) {
          const newErrors = entityErrorsToErrorsMap(entity.errors, messages);
          // logger.debug('Validation errors', newErrors, source);
          callback(newErrors);
        } else {
          callback(undefined);
        }
      } catch (e) {
        logger.error(e);
        callback(undefined);
      }
    };
  }
  return () => callback(undefined);
}
